import api from '../api';
import swal from '../../../../../helpers/swal.lib';
import apiMessages from '../../../../../helpers/apiMessages';

export const openCloseNotifCotizaciones = (isOpen) => ({
  type: "OPEN_CLOSE_NOTIF_COTIZACIONES",
  isOpen,
});

export const showHideFormCotizaciones = (showHideFormCotizaciones) => ({
  type: "SET_SHOWHIDE_FORM_COTIZACIONES",
  showHideFormCotizaciones,
});

export const sendingText = (showSendingText) => ({
  type: "SET_SHOWHIDE_SENDING_TEXT",
  showSendingText
});

export const sendDeclaration = (data) => async (dispatch) => {
  dispatch(sendingText(true));
  const res = await api.postDeclaration(data);
  // if(res.status === 200) {
  if(res.Success) {
    dispatch(openCloseNotifCotizaciones(true));
  } else {
    swal.alertConfirm(null, apiMessages.errorDefault);
  }
  dispatch(sendingText(false));
};
